export default __webpack_public_path__ + "static/media/img-2.35ed085b.png";